import { FC } from "react";
import { HiSquares2X2 } from "react-icons/hi2";

import { cn } from "@/lib/cn";

interface DatatableFocusAreaDisplayViewProps {
  className?: string;
  displayValue: string;
}

export const DatatableFocusAreaDisplayView: FC<DatatableFocusAreaDisplayViewProps> = ({ className, displayValue }) => {
  return (
    <>
      <HiSquares2X2 className={cn("h-4 w-4 text-foreground/60", className)} />
      <span className="text-xs">{displayValue}</span>
    </>
  );
};
